// Entidade da escritura (ponto 2 do plano, Sónia, out/2026): tipo + nome com pesquisa na tabela "entidades".
// Se a entidade não existir, escreve-se o nome e guarda-se como nova (fica para as próximas vezes).
import React, { useEffect, useState } from "react";

export const TIPOS_ENTIDADE = ["Cartório", "Solicitador", "Advogado", "Plataforma Legal", "Outro"];
const norm = (t) => String(t || "").trim().toLowerCase();

// valor: { tipo, id, nome } · onChange recebe { tipo, id, nome, morada, telefone } (morada/telefone só quando vêm da lista)
export default function EntidadeEscritura({ supabase, valor = {}, onChange, perfilId, estilo = {}, desativado = false }) {
  const [lista, setLista] = useState([]);
  const [texto, setTexto] = useState(valor.nome || "");
  const [aberto, setAberto] = useState(false);
  const [erro, setErro] = useState("");
  const tipo = valor.tipo || "";
  useEffect(() => { setTexto(valor.nome || ""); }, [valor.nome]);
  useEffect(() => {
    let vivo = true;
    // se a lista não se conseguir ler, o campo continua a funcionar como texto
    try {
      Promise.resolve(supabase.from("entidades").select("id, tipo, nome, morada, telefone").order("nome"))
        .then((r) => { if (vivo) setLista(r?.data || []); }).catch(() => {});
    } catch (e) { /* sem lista de entidades */ }
    return () => { vivo = false; };
  }, [supabase]);
  const doTipo = lista.filter((e) => !tipo || e.tipo === tipo);
  const sugestoes = doTipo.filter((e) => !norm(texto) || norm(e.nome).includes(norm(texto))).slice(0, 8);
  const existe = doTipo.find((e) => norm(e.nome) === norm(texto));
  const escolher = (e) => { setTexto(e.nome); setAberto(false); setErro(""); onChange({ tipo: e.tipo, id: e.id, nome: e.nome, morada: e.morada || "", telefone: e.telefone || "" }); };
  const criar = async () => {
    if (!tipo) { setErro("Escolha primeiro o tipo de entidade."); return; }
    const { data, error } = await supabase.from("entidades").insert({ tipo, nome: texto.trim(), criado_por: perfilId || null }).select().single();
    if (error) { setErro("Não foi possível guardar a entidade: " + error.message); return; }
    setLista((l) => [...l, data]); escolher(data);
  };
  const inp = { width: "100%", padding: "8px 10px", border: "1.5px solid #ece9e3", borderRadius: 8, fontSize: 13, boxSizing: "border-box", fontFamily: "inherit", ...estilo };
  const rot = { fontSize: 11, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 4, textTransform: "uppercase" };
  return (
    <div style={{ display: "grid", gridTemplateColumns: "minmax(140px, 1fr) 2fr", gap: 8 }}>
      <div>
        <label style={rot} htmlFor="entidade-tipo">Tipo de entidade</label>
        <select id="entidade-tipo" value={tipo} disabled={desativado} onChange={(e) => onChange({ tipo: e.target.value, id: null, nome: texto })} style={inp}>
          <option value="">Selecionar…</option>
          {TIPOS_ENTIDADE.map((t) => <option key={t}>{t}</option>)}
        </select>
      </div>
      <div style={{ position: "relative" }}>
        <label style={rot} htmlFor="entidade-nome">Nome da entidade</label>
        <input id="entidade-nome" value={texto} disabled={desativado} placeholder="Procurar ou escrever…" autoComplete="off" style={inp}
          onFocus={() => setAberto(true)} onBlur={() => setTimeout(() => setAberto(false), 150)}
          onChange={(e) => { setTexto(e.target.value); setAberto(true); onChange({ tipo, id: null, nome: e.target.value }); }} />
        {aberto && !desativado && (sugestoes.length > 0 || (texto.trim() && !existe)) && (
          <div style={{ position: "absolute", zIndex: 20, top: "100%", left: 0, right: 0, background: "#fff", border: "1.5px solid #d6deef", borderRadius: 8, marginTop: 2, boxShadow: "0 4px 14px rgba(18,36,79,.12)", maxHeight: 220, overflowY: "auto" }}>
            {sugestoes.map((e) => (
              <button type="button" key={e.id} onMouseDown={() => escolher(e)} style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", borderBottom: "1px solid #f1f1ee", padding: "7px 10px", cursor: "pointer", fontSize: 12.5 }}>
                <b>{e.nome}</b> <span style={{ color: "#8a909d" }}>· {e.tipo}{e.morada ? " · " + e.morada : ""}</span>
              </button>))}
            {texto.trim() && !existe && (
              <button type="button" onMouseDown={criar} style={{ display: "block", width: "100%", textAlign: "left", background: "#f1f4fa", border: "none", padding: "8px 10px", cursor: "pointer", fontSize: 12.5, color: "#12244f", fontWeight: 700 }}>
                + Guardar "{texto.trim()}" como nova entidade{tipo ? ` (${tipo})` : ""}
              </button>)}
          </div>)}
        {valor.id && <div style={{ fontSize: 11, color: "#0f7a47", marginTop: 3 }}>✓ Entidade da lista</div>}
        {erro && <div role="alert" style={{ fontSize: 12, color: "#b3261e", fontWeight: 600, marginTop: 3 }}>⚠ {erro}</div>}
      </div>
    </div>
  );
}
